import {defaultError, WebError} from "@hybird/core/error";
import {getAllMethodNames} from "@hybird/core/lib";

export class HybirdBridge {
  ready(event) {

  }
}

/**
 * Bridge基础类, 不允许直接new
 */
export class Core {
  _eventFns = {};
  _eventIds = {};
  _index = 0;
  _readyFn = [];
  _isReady = false;

  constructor() {
    if (new.target === Core) {
      throw WebError.code(defaultError.NOT_CONSTRUCTOR);
    }
  }

  /**
   * 增加event function
   * @param eventName
   * @param event
   * @param topic
   * @param params
   * @param filter
   * @param isOne
   * @return {number}
   * @private
   */
  _addEventFn(eventName, event, {topic = eventName, filter = () => true, isOne = false}) {
    const fns = this._getEventFn(eventName, {isOne});

    const index = this._index;
    this._index++;

    //保证isOne只保留一个
    const items = {
      topic, event, filter, index, isOne
    };

    if (isOne) {
      fns.events = [];
    }
    if (!fns.events) {
      fns.events = [];
    }

    fns.events.push(items);
    this._eventIds[eventName] = eventName;
  }

  /**
   * 获取所有的event function
   * @param eventName 事件名称
   * @param isOne 是否是一个
   * @return {{
   *   events: [{
   *         topic:String, //订阅地址
   *         event: function({}), //回调的事件
   *         filter: function({}): Boolean, //过滤返回的数据
   *         index: Number, //当前的eventId
   *         isOne: Boolean, //是否返回给flutter端
   *   }], //所有事件的集合
   *   isOne: Boolean, //是否返回给flutter端
   * }} 返回对象
   */
  _getEventFn(eventName, {isOne = false} = {}) {
    let fns;
    //获取存储数据
    if (this._eventFns[eventName]) {
      fns = this._eventFns[eventName];

      if (!fns.isOne) {
        fns.isOne = isOne;
      }
    } else {
      this._eventFns[eventName] = fns = {
        events: [], isOne: isOne
      };
    }

    return fns;
  }

  /**
   * 删除指定id的event
   * @param event eventId
   * @private
   * @param eventName
   * @param topic
   */
  _removeEventFn(eventName, {event, topic} = {}) {
    const fns = this._getEventFn(eventName);
    if (event) {
      fns.events = fns.events.filter((value) => value.event !== event);
    } else if (topic) {
      fns.events = fns.events.filter((value) => value.topic !== topic);
    } else {
      fns.events = [];
    }
  }

  /**
   * 发送消息
   * @param name 调用的方法
   * @param params 参数
   * @param namespace 命名空间
   * @param parseResult
   * @return {Promise<{
   *   code:int,//返回的code码
   *   data:Object, //当前方法返回的对象信息
   *   event: {String:String} //当前调用产生的event
   *   method: {String:function({})}
   * }>}
   */
  invoke(name, params, {namespace = "", parseResult = true} = {}) {
    if (typeof this[name] === "function") {
      this[name]();
    }
  }

  /**
   * 监听方法
   * @param name{String} 监听的名称
   * @param event{function({})} function
   * @param listenName
   * @param params
   * @param filter{function({}): boolean} 过滤
   * @param namespace{String}
   * @param isOne
   * @param isSend
   * @return {Promise<{cancel:function}>} eventId
   */
  on(name, event, {
    topic = name, params = {}, filter = () => true, namespace = "", isOne = false, isSend = false, off
  } = {}) {
    if (typeof event !== "function") {
      throw WebError.code(defaultError.ILLEGAL_ARGUMENT, {
        msg: "event is not function"
      });
    }
  }

  /**
   * 删除监听方法
   * @param name eventId
   * @param event
   * @param namespace
   * @param params
   * @param topic
   * @param isSend
   * @param off
   */
  // eslint-disable-next-line no-unused-vars
  off(name, {event, namespace, params, topic, isSend = false, off} = {}) {
  }

  parseName(name, namespace) {
    return namespace ? `${namespace}.${name}` : name;
  }

  /**
   * 准备就绪
   * @param event{function}
   * @return Promise<Void> 可以await
   */
  // eslint-disable-next-line no-unused-vars
  ready(event) {
  }
}

export class BridgeMethod {
  excludeMethodName = ["constructor", "invoke", "isSupport", "createProxy"];

  constructor() {
    const names = getAllMethodNames(this, this.excludeMethodName, BridgeMethod);

    for (const i in names) {
      const methodName = names[i];

      if (!this[methodName] || !(this[methodName] instanceof Function)) {
        continue;
      }

      if (HybirdBridge.prototype[names[i]]) {
        console.warn(this, `BridgeMethod ${methodName} 已经存在`);
      }

      HybirdBridge.prototype[methodName] = this[methodName].bind(this);
    }
  }
}